import React, { ReactElement } from "react";
import { Select, SelectProps } from "antd";
import DropdownSVG from "../../icons/Dropdown.svg";
import "./index.less";

export type { SelectProps as SettingSelectorProps } from "antd";

export const SettingSelector: React.FC<SelectProps> = ({ className, ...props }): ReactElement => {
    return (
        <Select
            className={`Setting-Selector ${className}`}
            suffixIcon={
                <div className="dropdownIcon">
                    <img src={DropdownSVG} />
                </div>
            }
            tabIndex={-1}
            {...props}
        />
    );
};
